import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { AddonButton } from '../../AddonButton';
import { Base } from '../../Base';
import Svg from '../../Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Message-root_1jQn8",
  "icon": "Message-icon_2MFxA",
  "content": "Message-content_1Effi",
  "iconWrapper": "Message-iconWrapper_3m0cK",
  "closeWrapper": "Message-closeWrapper_7_cc1",
  "footer": "Message-footer_YptLx",
  "withIcon": "Message-withIcon_11ysT",
  "withBackground": "Message-withBackground_2zqzO",
  "withHighlight": "Message-withHighlight_myWu_"
};
const iconsMap = {
  info: 'infoWire',
  success: 'successWire',
  warning: 'warningWire',
  danger: 'dangerWire',
  unknown: 'questionWire',
  progress: 'infoWire'
};
function Message({
  title,
  intent = 'info',
  mode = 'light',
  children,
  dismissible,
  withIcon,
  withHighlight,
  withBackground,
  buttons,
  buttonsAlign = 'start',
  className,
  classes,
  onDismiss,
  ...extraProps
}) {
  const blockVariant = typeof title === 'string' && title.length > 0;
  const inlineVariant = !blockVariant;
  const hasCloseButton = dismissible === true && typeof onDismiss === 'function';
  const rootClasses = clsx(styles.root, {
    [styles.withIcon]: withIcon,
    [styles.withHighlight]: withHighlight,
    [styles.withBackground]: withBackground
  }, className);
  const contentClasses = clsx(styles.content, classes?.content);
  return /*#__PURE__*/_jsxs(Root, {
    intent: intent,
    className: rootClasses,
    ...extraProps,
    children: [withIcon && /*#__PURE__*/_jsx(Base, {
      flex: true,
      flexShrink0: true,
      flexAlignItemsCenter: true,
      className: styles.iconWrapper,
      children: /*#__PURE__*/_jsx(Svg, {
        name: iconsMap[intent],
        size: "4x",
        className: styles.icon
      })
    }), blockVariant && /*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexCol: true,
      gap: "spacing-3x",
      flexGrow1: true,
      children: [/*#__PURE__*/_jsxs(Base, {
        flex: true,
        gap: "spacing-2x",
        className: styles.header,
        children: [/*#__PURE__*/_jsx(Title, {
          flexGrow1: true,
          children: title
        }), hasCloseButton && /*#__PURE__*/_jsx(Base, {
          flex: true,
          flexShrink0: true,
          flexAlignItemsCenter: true,
          className: styles.closeWrapper,
          children: /*#__PURE__*/_jsx(CloseButton, {
            mode: mode,
            onClick: onDismiss
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: contentClasses,
        children: children
      }), /*#__PURE__*/_jsx(Footer, {
        buttons: buttons,
        buttonsAlign: buttonsAlign
      })]
    }), inlineVariant && /*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexCol: true,
      gap: "spacing-3x",
      flexGrow1: true,
      children: [/*#__PURE__*/_jsxs(Base, {
        flex: true,
        gap: "spacing-2x",
        children: [/*#__PURE__*/_jsx(Base, {
          flexGrow1: true,
          className: contentClasses,
          children: children
        }), hasCloseButton && /*#__PURE__*/_jsx(Base, {
          flex: true,
          flexShrink0: true,
          flexAlignItemsCenter: true,
          className: styles.closeWrapper,
          children: /*#__PURE__*/_jsx(CloseButton, {
            mode: mode,
            onClick: onDismiss
          })
        })]
      }), /*#__PURE__*/_jsx(Footer, {
        buttons: buttons,
        buttonsAlign: buttonsAlign
      })]
    })]
  });
}
function Root(props) {
  return /*#__PURE__*/_jsx(Base, {
    flex: true,
    gap: "spacing-2x",
    boxSizing: "border",
    paddingTop: "spacing-4x",
    paddingRight: "spacing-4x",
    paddingBottom: "spacing-4x",
    paddingLeft: "spacing-4x",
    borderRadius: "1x",
    backgroundColor: "white",
    ...props
  });
}
function Title(props) {
  return /*#__PURE__*/_jsx(Base, {
    tagName: "h3",
    size: "base",
    weight: "semibold",
    margin: "none",
    ...props
  });
}
function Footer(props) {
  const buttons = React.Children.toArray(props.buttons).filter(React.isValidElement);
  if (!buttons.length) return null;
  return /*#__PURE__*/_jsx(Base, {
    flex: true,
    flexWrap: true,
    flexJustifyCenter: props.buttonsAlign === 'center',
    flexJustifyEnd: props.buttonsAlign === 'end',
    className: styles.footer,
    children: buttons
  });
}
function CloseButton(props) {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsx(AddonButton, {
    intent: "remove",
    size: "xs",
    hitzone: "overlay",
    ...props,
    children: __('Dismiss')
  });
}
export { Message };